module.exports = __webpack_public_path__ + "static/media/cloud-sleet.793d2367.svg";